import { ReportConversationReason } from '../../types/GraphqlTypes';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_OBJECT, TRIGGER_TYPE, type TriggerLocation } from './globals';
import { trackRenterProfileEvent } from '../../analytics';
import { getZrmUserInfo } from '@zg-rentals/clickstream';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

const REPORT_PROBLEM_MODAL = 'report_problem_modal';
const EVENT_TEMPLATE_ID = '415';

// https://dataportal.zillowgroup.net/event-registry/6375
export const emitReportConversationAsSpamEvent = (user: ZrmClickstreamUserOrNull, triggerLocation: TriggerLocation) =>
  trackRenterProfileEvent({
    envelope: {
      event_type_id: '6375',
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'spam_radio_button',
      trigger_object_nm: REPORT_PROBLEM_MODAL,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ReportConversation,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    renter_profile: null,
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6376
export const emitReportConversationAsDiscriminatoryEvent = (
  user: ZrmClickstreamUserOrNull,
  triggerLocation: TriggerLocation,
) =>
  trackRenterProfileEvent({
    envelope: {
      event_type_id: '6376',
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'discriminatory_radio_button',
      trigger_object_nm: REPORT_PROBLEM_MODAL,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ReportConversation,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    renter_profile: null,
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6377
export const emitReportConversationAsOtherEvent = (user: ZrmClickstreamUserOrNull, triggerLocation: TriggerLocation) =>
  trackRenterProfileEvent({
    envelope: {
      event_type_id: '6377',
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'other_radio_button',
      trigger_object_nm: REPORT_PROBLEM_MODAL,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ReportConversation,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    renter_profile: null,
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6378
export const OPEN_REPORT_PROBLEM_MODAL_EVENT_TYPE_ID = '6378';
export const emitOpenReportProblemModalEvent = (user: ZrmClickstreamUserOrNull, triggerLocation: TriggerLocation) =>
  trackRenterProfileEvent({
    envelope: {
      event_type_id: OPEN_REPORT_PROBLEM_MODAL_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Impression,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'report_conversation_modal',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewContent,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    renter_profile: null,
    ...getZrmUserInfo(user),
  });

export const reportReasonClickstreamEventMap = {
  [ReportConversationReason.Spam]: emitReportConversationAsSpamEvent,
  [ReportConversationReason.DiscriminatoryOrAbusive]: emitReportConversationAsDiscriminatoryEvent,
  [ReportConversationReason.Other]: emitReportConversationAsOtherEvent,
} as const;
